export const API_HOST = process.env.REACT_APP_API;
export const S3_HOST = process.env.REACT_APP_S3;
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
